import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../App.css";

const API = "https://slimlinehardwarefittings.com/backend";

export default function ManageBlogs() {

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editBlog, setEditBlog] = useState(null);

  const [editForm, setEditForm] = useState({
    title: "",
    excerpt: "",
    category: "",
    tags: "",
    content: ""
  });

  const [editImage, setEditImage] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  // GET BLOGS
  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API}/blogs.php`);

      const data = Array.isArray(res.data)
        ? res.data
        : res.data.blogs || [];

      setBlogs(data);

    } catch (err) {
      console.log(err);
      alert("Blogs load nahi hue");
    } finally {
      setLoading(false);
    }
  };

  // DELETE BLOG
  const deleteBlog = async (id) => {
    if (!window.confirm("Delete karna hai?")) return;

    try {
      await axios.get(`${API}/delete-blog.php?id=${id}`);

      setBlogs((prev) => prev.filter((b) => b.id !== id));

      alert("Blog Deleted");

    } catch (err) {
      console.log(err);
      alert("Delete failed");
    }
  };

  // START EDIT
  const startEdit = (blog) => {
    setEditBlog(blog.id);

    setEditForm({
      title: blog.title || "",
      excerpt: blog.excerpt || "",
      category: blog.category || "",
      tags: blog.tags || "",
      content: blog.content || ""
    });

    setEditImage(null);
  };

  // INPUT CHANGE
  const handleEditChange = (e) => {
    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value
    });
  };

  // UPDATE BLOG (FULL FIX)
 const updateBlog = async (id) => {
  try {

    const formData = new FormData();

    formData.append("id", id);
    formData.append("title", editForm.title);
    formData.append("excerpt", editForm.excerpt);
    formData.append("category", editForm.category);
    formData.append("tags", editForm.tags);
    formData.append("content", editForm.content);

    if (editImage) {
      formData.append("image", editImage);
    }

    const res = await axios.post(
      `${API}/update-blog.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );

    console.log(res.data); // ✅ yaha res defined hai

    alert(res.data.message);

    setEditBlog(null);

  } catch (err) {
    console.log(err);
    alert("Update failed");
  }
};


  if (loading) return <h2>Loading...</h2>;

  return (
    <div className="manage-blogs">

      <div className="manage-header">
        <h1>Manage Blogs</h1>

        <button onClick={() => navigate("/dashboard")}>
          + New Blog
        </button>
      </div>

      {blogs.length === 0 && <p>No Blogs Found</p>}

      {blogs.map((blog) => (
        <div className="blog-card" key={blog.id}>

          <div className="blog-content">

            {/* EDIT MODE */}
            {editBlog === blog.id ? (

              <div className="edit-form">

                <input
                  type="text"
                  name="title"
                  value={editForm.title}
                  onChange={handleEditChange}
                  placeholder="Title"
                />

                <input
                  type="text"
                  name="excerpt"
                  value={editForm.excerpt}
                  onChange={handleEditChange}
                  placeholder="Excerpt"
                />

                <input
                  type="text"
                  name="category"
                  value={editForm.category}
                  onChange={handleEditChange}
                  placeholder="Category"
                />

                <input
                  type="text"
                  name="tags"
                  value={editForm.tags}
                  onChange={handleEditChange}
                  placeholder="Tags"
                />

                <textarea
                  name="content"
                  value={editForm.content}
                  onChange={handleEditChange}
                  placeholder="Content"
                />

                {/* IMAGE UPLOAD */}
                <input
                  type="file"
                  onChange={(e) => setEditImage(e.target.files[0])}
                />

                {/* IMAGE PREVIEW */}
                {editImage ? (
                  <img
                    src={URL.createObjectURL(editImage)}
                    alt="preview"
                    style={{ width: "150px" }}
                  />
                ) : (
                  blog.image && (
                    <img
                      src={`${API}/uploads/${blog.image}`}
                      alt="old"
                      style={{ width: "150px" }}
                    />
                  )
                )}

                <button
               
                  onClick={() => updateBlog(blog.id)}
                  style={{ background: "green", color: "white" }}
                >
                  Save
                </button>

                <button onClick={() => setEditBlog(null)}>
                  Cancel
                </button>

              </div>

            ) : (

              <>
                <h2>{blog.title}</h2>
                <p>{blog.excerpt}</p>
                <p>{blog.category} {blog.tags}</p>
              </>

            )}

          </div>

          {/* ACTIONS */}
          <div className="blog-actions">

            <a
              href={`/blogs/${blog.slug}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View
            </a>

            <button onClick={() => startEdit(blog)}>
              Edit
            </button>

            <button onClick={() => deleteBlog(blog.id)}>
              Delete
            </button>

          </div>

        </div>
      ))}

    </div>
  );
}